import styled from "@emotion/styled";
import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { NokCrudType } from "../../types/types";
import SelectBox, { menuItemType } from "../selectBox";
import { SelectChangeEvent } from "@mui/material";
import theme from "../../theme";
import useGetAllCustomer from "../../hooks/useGetAllCustomer";
import { isOnlyNumber } from "../../utils/util";
import { Label } from "../common/Label";
import { TextInput } from "../common/TextInput";
import { useI18n } from "../../locales";

const { sm } = theme.screen;

const InputField: React.FC<{
  form: NokCrudType;
  setForm: Dispatch<SetStateAction<NokCrudType>>;
}> = (props) => {
  const { form, setForm } = props;
  const { t } = useI18n();

  const handleSelectBox = (event: SelectChangeEvent<string>) => {
    setForm((prevState) => ({
      ...prevState,
      related_id: event.target.value,
    }));
  };

  // 소유자 연락처 리스트 가져오기
  const { data: relatedIdList } = useGetAllCustomer({
    page: 0,
    searchKey: "",
    area: "",
    limit: -1,
  });
  let relatedIdListType: menuItemType[] = [
    {
      value: -1,
      title: t.manageNok.selectOwner,
    },
  ];
  if (relatedIdList) {
    relatedIdList.list.filter((item) => {
      relatedIdListType.push({
        value: item.id,
        title: item.seq + ". " + item.name,
      });
    });
  }

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const isIdErr = form.id.length > 0 && !isOnlyNumber(form.id);

  return (
    <UserInfoWrapper>
      <UserInfo>
        <RowContainer>
          {/* 소유자명 & 소유자 연락처 */}
          <InputWrapper>
            <Label text={t.manageNok.nameLabel} htmlFor="name" isRequired />
            <TextInput
              autoComplete="off"
              id="name"
              name="name"
              width={"100%"}
              onChange={handleChange}
              value={form.name}
              placeholder={t.manageNok.namePlaceholder}
              maxLength={20}
            />
          </InputWrapper>
          <InputWrapper style={{ position: "relative" }}>
            <Label
              text={t.manageNok.contactLabel}
              htmlFor="id"
              isRequired
            />

            <TextInput
              autoComplete="off"
              id="id"
              name="id"
              width={"100%"}
              onChange={handleChange}
              value={form.id}
              placeholder={t.manageNok.contactPlaceholder}
              minLength={10}
              maxLength={11}
            />
            {isIdErr && (
              <PwError style={{ position: "absolute", bottom: "-20px" }}>
                {t.manageNok.contactOnlyNumbers}
              </PwError>
            )}
          </InputWrapper>

          <InputWrapper>
            <Label
              text={t.manageNok.relationshipLabel}
              htmlFor="relation"
              isRequired
            />

            <TextInput
              autoComplete="off"
              id="relation"
              name="relation"
              width={"100%"}
              onChange={handleChange}
              value={form.relation}
              placeholder={t.manageNok.relationshipPlaceholder}
              maxLength={20}
            />
          </InputWrapper>

          <InputWrapper>
            <Label text={t.manageNok.ownerLabel} htmlFor="related_id" isRequired />

            <SelectBox
              filter={form.related_id}
              menuItems={relatedIdListType}
              width={"100%"}
              handleChange={handleSelectBox}
              srLabel={t.manageNok.ownerLabel}
            />
          </InputWrapper>
        </RowContainer>
      </UserInfo>
    </UserInfoWrapper>
  );
};

const UserInfoWrapper = styled.div`
  background: ${theme.color.neutral_50};
  border-radius: 10px;
  padding-left: 40px;
  padding-right: 30px;
  padding-top: 30px;
  padding-bottom: 40px;
  width: 100%;
  display: flex;
  gap: 44px;
  margin-bottom: 40px;
  @media (max-width: ${sm}px) {
    padding: 10px;
    padding-bottom: 20px;
  }
`;

const UserInfo = styled.div`
  width: 100%;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const PwError = styled.p`
  font-size: 10px;
  color: ${theme.color.red_500};
  position: absolute;
  bottom: -30px;
  left: 3px;
  width: 200px;
`;

const RowContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 26px;
`;
export default InputField;
